import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./DirectionsDialog.css";
import MultiSelectModal from "./MultiSelectModal";
import AlertModal from "./AlertModal";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import Place from "../../Models/Place";
import { hasRealPhoto } from "../../Common/placeEnrichment";

// Google's own consumer Directions (maps/dir) and the Routes API this
// dialog draws a Path with both cap out around the same point: the Routes
// API accepts at most 25 intermediate waypoints, but Google Maps' web/app
// UI only reliably follows a "waypoints=" link with up to 9 — beyond that
// it's known to silently drop or reorder stops. Warn well before the harder
// Routes API ceiling, since the Google Maps link (used to re-open this same
// route) is the tighter real-world limit.
const GOOGLE_MAPS_WAYPOINT_LIMIT = 9;

const DirectionsDialogComponent = (props) => {
  const dispatch = useDispatch();
  // const [DirectionsFromPlace, setDirectionsFromPlace] = useState([]);
  // const [DirectionsToPlace, setDirectionsToPlace] = useState([]);
  // const [DirectionsWaypoints, setDirectionsWaypoints] = useState([]);
  const [which_one, set_which_one] = useState("from");

  const [MultiselectItems, setMultiselectItems] = useState([]);
  const [MultiselectSelectedItems, setMultiselectSelectedItems] = useState([]);
  const [MultiselectMode, setMultiselectMode] = useState("uni");
  //const [MultiselectCallback, setMultiselectCallback] = useState(null);
  const [MultiselectTitle, setMultiselectTitle] = useState("Select");
  const [MultiselectSearchText] = useState("");
  const [ShowMultiselect, setShowMultiselect] = useState(null);
  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [TravelMode, setTravelMode] = useState("Walking");
  const [ShapeToCreate, setShapeToCreate] = useState("Path");
  const [Operation, setOperation] = useState("Directions");
  // Draw's own Routes API call used to run fire-and-forget: createPath()
  // fired shapeFromDirections() without awaiting it, then closed the whole
  // dialog immediately — the fetch then completed entirely invisibly, with
  // no spinner and no confirmation once the dialog was already gone. Found
  // 2026-09-23 (reported for web's mobile mode; the same class of bug was
  // already fixed on native mobile's DirectionsDialog.js the day before).
  const [working, setWorking] = useState(false);
  const [drawSuccessMsg, setDrawSuccessMsg] = useState("");

  let DirectionsFromLocation = useSelector((state) => state.DirectionsFromLocation);
  let DirectionsToLocation = useSelector((state) => state.DirectionsToLocation);
  let DirectionsWaypointsLocation = useSelector((state) => state.DirectionsWaypointsLocation);
  let showHiddenPlace = useSelector((state) => state.showHiddenPlace);

  useEffect(() => {
    // if (fromLoc != null) setDirectionsFromLocation(fromLoc);
    // if (toLoc != null) setDirectionsToLocation(toLoc);
    // if (waypointsArray.length !== 0) DirectionsWaypointsLocation(waypointsArray);
    if (typeof window.DirectionsWaypointPlaces === "undefined") window.DirectionsWaypointPlaces = [];
    if (typeof window.DirectionsFromPlace === "undefined") window.DirectionsFromPlace = [];
    if (typeof window.DirectionsToPlace === "undefined") window.DirectionsToPlace = [];
    if (window.DirectionsFromLocation === null) {
      const _place = window.guide_obj.places.getPlace(props.id);
      if (_place !== null) {
        window.DirectionsFromLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
        dispatch(
          slice1Actions.setDirectionsFromLocation({
            value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
          })
        );
      }
    } else if (window.DirectionsToLocation === null) {
      const _place = window.guide_obj.places.getPlace(props.id);
      if (_place !== null) {
        if (
          window.DirectionsFromLocation.Name !== _place.Name ||
          window.DirectionsFromLocation.Lat !== _place.Lat ||
          window.DirectionsFromLocation.Longi !== _place.Longi
        ) {
          window.DirectionsToLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
          dispatch(
            slice1Actions.setDirectionsToLocation({
              value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
            })
          );
        }
      }
    }
  }, [props.id]);

  // Cleanup for the schedule travel-banner's quick one-leg preview
  // (SchedulePanel.js's openDirectionsForLeg sets DirectionsAutoClearOnExit
  // before opening this dialog). Runs on unmount rather than hooking every
  // way the dialog can close (the Offcanvas's own X/backdrop/Escape all
  // dispatch setShowOffcanvas(false) directly in App.js, bypassing this
  // component's own exitDialog entirely) — this component only mounts
  // while the Offcanvas is shown (see the comment below), so unmount is the
  // one point every close path is guaranteed to pass through. Real report:
  // exiting without pressing "Clear" left From/To markers on the Map
  // needing manual cleanup. Found 2026-09-26.
  useEffect(() => {
    return () => {
      if (window.DirectionsAutoClearOnExit) {
        window.DirectionsAutoClearOnExit = false;
        DeleteDirectionsMarkers();
      }
    };
  }, []);

  // "Edit Directions" (PlaceModal.js, a Path with a stored DirectionsRoute)
  // sets window.DirectionsEditPlaceId then opens this dialog — hydrate the
  // From/Waypoints/To picks and travel mode from that place's own stored
  // route, and jump straight to Draw/Path, instead of starting from an
  // empty route. Runs once per open (this component only mounts while the
  // Offcanvas is shown — see App.js's `{ShowOffcanvas ? <…> : null}`).
  useEffect(() => {
    if (!window.DirectionsEditPlaceId) return;
    const editPlace = window.guide_obj.places.getPlace(window.DirectionsEditPlaceId);
    if (!editPlace || !editPlace.DirectionsRoute) {
      window.DirectionsEditPlaceId = null;
      return;
    }
    const route = editPlace.DirectionsRoute;
    window.DirectionsFromLocation = route.from || null;
    window.DirectionsToLocation = route.to || null;
    window.DirectionsWaypointsLocation = route.waypoints || [];
    window.DirectionsFromPlace = route.from?.ID ? [{ Name: route.from.Name, ID: route.from.ID }] : [];
    window.DirectionsToPlace = route.to?.ID ? [{ Name: route.to.Name, ID: route.to.ID }] : [];
    window.DirectionsWaypointPlaces = (route.waypoints || [])
      .filter((wp) => wp.ID)
      .map((wp) => ({ Name: wp.Name, ID: wp.ID }));
    dispatch(slice1Actions.setDirectionsFromLocation({ value: route.from || null }));
    dispatch(slice1Actions.setDirectionsToLocation({ value: route.to || null }));
    dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: route.waypoints || [] }));
    setOperation("Draw");
    setShapeToCreate("Path");
    if (route.travelMode) setTravelMode(route.travelMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectPlaces = (which) => {
    set_which_one(which);
    let selectedPlaces = [];
    let Places =
      which === "waypoints"
        ? window.DirectionsWaypointPlaces
        : which === "from place"
        ? window.DirectionsFromPlace
        : window.DirectionsToPlace;
    Places.forEach((place) =>
      selectedPlaces.push({
        label: place.Name,
        name: place.Name,
        value: place.ID,
      })
    );
    setMultiselectItems(window.guide_obj.places.getPlacesToDisplay(null));
    setMultiselectSelectedItems(selectedPlaces);
    setMultiselectMode(which === "waypoints" ? "multi" : "uni");
    setMultiselectTitle(`Select ${which}`);
    setShowMultiselect(true);
  };

  const selectPlacesCallBack = (Places) => {
    let _places = [];
    Places.forEach((place) => {
      _places.push({
        Name: place.label,
        ID: place.value,
      });
    });
    if (which_one === "waypoints") {
      let locs = [];
      _places.forEach((place) => {
        const _place = window.guide_obj.places.getPlace(place.ID);
        if (_place !== null) locs.push({ Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi });
      });
      window.DirectionsWaypointPlaces = _places;
      dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: locs }));
      window.DirectionsWaypointsLocation = locs;
    } else if (which_one === "from place") {
      if (_places.length === 0) return;
      const _place = window.guide_obj.places.getPlace(_places[0].ID);
      if (_place !== null) {
        window.DirectionsFromPlace = _places;
        dispatch(
          slice1Actions.setDirectionsFromLocation({
            value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
          })
        );
        window.DirectionsFromLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
      }
    } else {
      if (_places.length === 0) return;
      const _place = window.guide_obj.places.getPlace(_places[0].ID);
      if (_place !== null) {
        window.DirectionsToPlace = _places;
        window.DirectionsToLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
        dispatch(
          slice1Actions.setDirectionsToLocation({
            value: { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi },
          })
        );
        window.DirectionsToLocation = { Name: _place.Name, Lat: _place.Lat, Longi: _place.Longi };
      }
    }
  };

  const createPath = async () => {
    if (window.DirectionsFromLocation === null) {
      myAlert("Must select 'From' place");
      return;
    }
    if (window.DirectionsToLocation === null) {
      myAlert("Must select 'To' place");
      return;
    }
    setWorking(true);
    setDrawSuccessMsg("");
    const success = await shapeFromDirections();
    setWorking(false);
    // Dialog intentionally stays open either way (see shapeFromDirections'
    // own comment — lets another path be drawn right away without
    // reopening) — an error already showed its own myAlert, and a success
    // gets this inline confirmation instead of auto-closing, since the
    // dialog covers the map and the user can't otherwise see the new Path
    // appear behind it.
    if (success) {
      setDrawSuccessMsg(ShapeToCreate === "Path" ? "✓ Path added to map" : "✓ Area added to map");
    }
  };

  const decodePolyline = (encoded) => {
    const pts = [];
    let idx = 0, lat = 0, lng = 0;
    while (idx < encoded.length) {
      let shift = 0, result = 0, b;
      do { b = encoded.charCodeAt(idx++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);
      shift = result = 0;
      do { b = encoded.charCodeAt(idx++) - 63; result |= (b & 0x1f) << shift; shift += 5; } while (b >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);
      pts.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return pts;
  };

  const formatDistance = (meters) => {
    if (meters < 1000) return `${meters} m`;
    return `${(meters / 1000).toFixed(1)} km`;
  };

  const formatDuration = (durationStr) => {
    const seconds = parseInt(durationStr, 10) || 0;
    if (seconds < 60) return `${seconds} sec`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    const rem = minutes % 60;
    return rem > 0 ? `${hours} hr ${rem} min` : `${hours} hr`;
  };

  const shapeFromDirections = async () => {
    const apiKey = process.env.REACT_APP_ROUTES_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_KEY;
    const name = `${window.DirectionsFromLocation.Name}-${window.DirectionsToLocation.Name}`;
    const travelModeMap = { Walking: "WALK", Bicycling: "BICYCLE", Driving: "DRIVE" };
    const reqBody = {
      origin: { location: { latLng: { latitude: window.DirectionsFromLocation.Lat, longitude: window.DirectionsFromLocation.Longi } } },
      destination: { location: { latLng: { latitude: window.DirectionsToLocation.Lat, longitude: window.DirectionsToLocation.Longi } } },
      travelMode: travelModeMap[TravelMode] || "WALK",
      languageCode: "en-US",
    };
    if (window.DirectionsWaypointsLocation.length > 0)
      reqBody.intermediates = window.DirectionsWaypointsLocation.map((wp) => ({
        location: { latLng: { latitude: wp.Lat, longitude: wp.Longi } },
      }));
    try {
      const response = await fetch("https://routes.googleapis.com/directions/v2:computeRoutes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": apiKey,
          "X-Goog-FieldMask": "routes.polyline.encodedPolyline,routes.legs.distanceMeters,routes.legs.duration,routes.legs.steps.navigationInstruction",
        },
        body: JSON.stringify(reqBody),
      });
      if (!response.ok) {
        console.error("Routes API error:", await response.text());
        myAlert("Failed to get directions");
        return false;
      }
      const data = await response.json();
      const route = data.routes?.[0];
      if (!route) { myAlert("No route found"); return false; }
      const decoded = decodePolyline(route.polyline.encodedPolyline);
      const mapCoordinate = { Lat: decoded[0].lat, Longi: decoded[0].lng };
      const points = decoded.map((p) => `${p.lng.toFixed(6)},${p.lat.toFixed(6)}`).join(":");
      let directions = "";
      if (route.legs) {
        for (const leg of route.legs)
          if (leg.steps)
            for (const step of leg.steps)
              if (step.navigationInstruction?.instructions)
                directions += step.navigationInstruction.instructions + "<br/>";
        const firstLeg = route.legs[0];
        if (firstLeg)
          directions += `Distance: ${formatDistance(firstLeg.distanceMeters || 0)}, Time: ${formatDuration(firstLeg.duration || "0s")}`;
      }
      // Same Google Maps web URL the "Directions" operation opens in a new
      // tab (buildGoogleMapsDirUrl below) — attached to the drawn Path place
      // itself (WalkAI's own generated paths already carry this same link;
      // a manually-drawn Path never did), so re-opening real turn-by-turn
      // directions for it later is one click on the place card instead of
      // re-picking From/Waypoints/To in this dialog again.
      const mapsUrl = ShapeToCreate === "Path" ? buildGoogleMapsDirUrl() : null;
      // The From/Waypoints/To this route was actually built from — stored on
      // the resulting Path place (place.DirectionsRoute) so "Edit
      // Directions" can reopen this same picked route later instead of only
      // being able to redraw a path from scratch. Real place IDs are kept
      // where known (so a renamed/moved place still resolves), Name/Lat/
      // Longi always kept as a fallback for a stop with no place ID (e.g. a
      // map-tap location).
      const directionsRoute =
        ShapeToCreate === "Path"
          ? {
              from: { ...window.DirectionsFromLocation, ID: window.DirectionsFromPlace?.[0]?.ID || null },
              to: { ...window.DirectionsToLocation, ID: window.DirectionsToPlace?.[0]?.ID || null },
              waypoints: window.DirectionsWaypointsLocation.map((wp, i) => ({
                ...wp,
                ID: window.DirectionsWaypointPlaces?.[i]?.ID || null,
              })),
              travelMode: TravelMode,
            }
          : null;
      if (ShapeToCreate === "Path") addPlaceToMap("PolyLine", points, directions, name, mapCoordinate, mapsUrl, directionsRoute);
      else addPlaceToMap("Polygon", points, undefined, undefined, mapCoordinate);
      // The dialog itself deliberately stays open after drawing (so another
      // path can be drawn without reopening it), but the From/Waypoints/To
      // pins used to linger on the map too — no longer needed now that a
      // drawn Path remembers its own route and "Edit Directions" can redraw
      // it, so a fresh route is picked each time instead of accidentally
      // reusing leftover markers from the last one.
      DeleteDirectionsMarkers();
      return true;
    } catch (err) {
      console.error("Routes API fetch error:", err);
      myAlert("Failed to get directions");
      return false;
    }
  };

  // A drawn Path had no photo of its own — the destination (To place, To
  // falling back to From when only that end has a real one) already has a
  // real photo most of the time, and reusing it beats the generic
  // placeholder every Path used to show in place lists/map markers.
  const destinationPhoto = (route) => {
    const tryPlace = (id) => {
      if (!id) return null;
      const place = window.guide_obj.places.getPlace(id);
      if (!place || !hasRealPhoto(place)) return null;
      return { Photo: place.Photo, Photo_m: place.Photo_m || place.Photo };
    };
    return tryPlace(route?.to?.ID) || tryPlace(route?.from?.ID);
  };

  const addPlaceToMap = (PType, Points, directions, name, mapCoordinate, mapsUrl, directionsRoute) => {
    // "Edit Directions" (PlaceModal.js) set this before opening the dialog —
    // update that same Path place instead of creating a second one.
    if (window.DirectionsEditPlaceId && PType === "PolyLine") {
      const editPlace = window.guide_obj.places.getPlace(window.DirectionsEditPlaceId);
      if (editPlace) {
        editPlace.Name = name != null ? name : editPlace.Name;
        editPlace.Lat = mapCoordinate.Lat;
        editPlace.Longi = mapCoordinate.Longi;
        editPlace.Points = Points;
        if (typeof directions !== "undefined") editPlace.Info = directions;
        if (mapsUrl) {
          editPlace.Hlink = `Google Maps Directions|${mapsUrl}`;
          editPlace.Link = { type: "url", value: mapsUrl, offset: "0" };
        }
        if (directionsRoute) editPlace.DirectionsRoute = directionsRoute;
        const editPhoto = directionsRoute ? destinationPhoto(directionsRoute) : null;
        if (editPhoto) { editPlace.Photo = editPhoto.Photo; editPlace.Photo_m = editPhoto.Photo_m; }
        window.DirectionsEditPlaceId = null;
        dispatch(slice1Actions.setGuide({ guide: null }));
        return;
      }
      window.DirectionsEditPlaceId = null;
    }
    let shape = "New Place";
    if (PType === "Polygon") shape = "New Area";
    else if (PType === "PolyLine") shape = "New Path";
    let new_place = new Place(window.guide_obj.places);
    new_place.Name = name != null ? name : shape;
    new_place.Lat = mapCoordinate.Lat;
    new_place.Longi = mapCoordinate.Longi;
    new_place.PType = PType;
    new_place.Points = Points;
    if (typeof directions !== "undefined") new_place.Info = directions;
    if (mapsUrl) {
      new_place.Hlink = `Google Maps Directions|${mapsUrl}`;
      new_place.Link = { type: "url", value: mapsUrl, offset: "0" };
    }
    if (directionsRoute) new_place.DirectionsRoute = directionsRoute;
    const newPhoto = directionsRoute ? destinationPhoto(directionsRoute) : null;
    if (newPhoto) { new_place.Photo = newPhoto.Photo; new_place.Photo_m = newPhoto.Photo_m; }
    window.guide_obj.places.addPlace(new_place);
    let _ShowHiddenPlace = JSON.parse(JSON.stringify(showHiddenPlace));
    _ShowHiddenPlace.push(new_place);
    dispatch(slice1Actions.setShowHiddenPlace({ value: _ShowHiddenPlace }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const getDirections = () => {
    if (Operation === "Draw") {
      createPath();
      return;
    }
    // if (window.DirectionsFromLocation === null) {
    //   myAlert("Must select 'From' place");
    //   return;
    // }
    if (window.DirectionsToLocation === null) {
      myAlert("Must select 'To' place");
      return;
    }
    showDirections();
  };

  // Google's waypoints param is visited in the order given — this used to
  // build the list backwards, which silently undid any order the user
  // picked. Straight index order now, matching moveWaypoint/shapeFromDirections.
  // Shared by showDirections (opens it directly) and shapeFromDirections
  // (attaches it to a drawn Path place, so the same From/Waypoints/To route
  // — e.g. a 10-place trip — can be reopened later from the place itself).
  const buildGoogleMapsDirUrl = () => {
    let waypoints = "";
    if (window.DirectionsWaypointsLocation.length !== 0) {
      waypoints = "&waypoints=" + window.DirectionsWaypointsLocation.map((wp) => `${wp.Lat},${wp.Longi}`).join("|");
    }
    let _url = `https://www.google.com/maps/dir/?api=1&destination=${window.DirectionsToLocation.Lat},${window.DirectionsToLocation.Longi}${waypoints}`;
    if (window.DirectionsFromLocation !== null)
      _url = `https://www.google.com/maps/dir/?api=1&origin=${window.DirectionsFromLocation.Lat},${window.DirectionsFromLocation.Longi}&destination=${window.DirectionsToLocation.Lat},${window.DirectionsToLocation.Longi}${waypoints}`;
    if (TravelMode === "Walking") _url = _url + "&travelmode=walking";
    else if (TravelMode === "Bicycling") _url = _url + "&travelmode=bicycling";
    else _url = _url + "&travelmode=driving";
    return _url;
  };

  const showDirections = () => {
    let win = window.open(buildGoogleMapsDirUrl(), "_blank");
    if (win) win.focus();
    exitDialog();
  };

  // Waypoints used to always route in whatever order getPlacesToDisplay
  // happened to list them (its own sort — alphabetical/category/etc.), not
  // the order the user actually wants to visit them in. Reordering here
  // (kept in lockstep with window.DirectionsWaypointPlaces, which shares the
  // same index-for-index order) lets the route be arranged freely.
  const moveWaypoint = (index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= window.DirectionsWaypointsLocation.length) return;
    const locs = window.DirectionsWaypointsLocation.slice();
    const places = window.DirectionsWaypointPlaces.slice();
    [locs[index], locs[newIndex]] = [locs[newIndex], locs[index]];
    [places[index], places[newIndex]] = [places[newIndex], places[index]];
    window.DirectionsWaypointsLocation = locs;
    window.DirectionsWaypointPlaces = places;
    dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: locs }));
  };

  const DeleteDirectionsMarkers = () => {
    window.DirectionsFromLocation = null;
    window.DirectionsToLocation = null;
    window.DirectionsWaypointsLocation = [];
    dispatch(slice1Actions.setDirectionsFromLocation({ value: null }));
    dispatch(slice1Actions.setDirectionsToLocation({ value: null }));
    dispatch(slice1Actions.setDirectionsWaypointsLocation({ value: [] }));
    dispatch(slice1Actions.setGuide({ guide: null }));
    window.DirectionsWaypointPlaces = [];
    window.DirectionsFromPlace = [];
    window.DirectionsToPlace = [];
    // Stop treating a fresh route as "Edit Directions" for whatever Path
    // was being edited before Clear was pressed.
    window.DirectionsEditPlaceId = null;
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Message" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };

  const exitDialog = () => {
    if (typeof props.onHidePrevious != "undefined") props.onHidePrevious();
    //props.onHide();
  };

  if (ShowMultiselect)
    return (
      <MultiSelectModal
        show={ShowMultiselect}
        onHide={() => setShowMultiselect(false)}
        MultiselectItems={MultiselectItems}
        MultiselectSelectedItems={MultiselectSelectedItems}
        MultiselectMode={MultiselectMode}
        MultiselectCallback={selectPlacesCallBack}
        MultiselectTitle={MultiselectTitle}
        MultiselectSearchText={MultiselectSearchText}
      />
    );
  else {
    return (
      <div className="dd-component">
        <div className="dd-section">
          <span className="dd-section-label">Operation</span>
          <div className="dd-seg">
            <button className={`dd-seg-btn${Operation === "Directions" ? " active" : ""}`} onClick={() => setOperation("Directions")}>Directions</button>
            <button className={`dd-seg-btn${Operation === "Draw" ? " active" : ""}`} onClick={() => setOperation("Draw")}>Draw</button>
          </div>
        </div>
        {Operation === "Draw" && (
          <div className="dd-section">
            <span className="dd-section-label">Shape</span>
            <div className="dd-seg">
              <button className={`dd-seg-btn${ShapeToCreate === "Path" ? " active" : ""}`} onClick={() => setShapeToCreate("Path")}>Path</button>
              <button className={`dd-seg-btn${ShapeToCreate === "Area" ? " active" : ""}`} onClick={() => setShapeToCreate("Area")}>Area</button>
            </div>
          </div>
        )}
        <div className="dd-section">
          <span className="dd-section-label">Travel Mode</span>
          <div className="dd-seg">
            <button className={`dd-seg-btn${TravelMode === "Walking" ? " active" : ""}`} onClick={() => setTravelMode("Walking")}>
              <FontAwesomeIcon icon={solid("person-walking")} /> Walking
            </button>
            <button className={`dd-seg-btn${TravelMode === "Bicycling" ? " active" : ""}`} onClick={() => setTravelMode("Bicycling")}>
              <FontAwesomeIcon icon={solid("bicycle")} /> Bicycling
            </button>
            <button className={`dd-seg-btn${TravelMode === "Driving" ? " active" : ""}`} onClick={() => setTravelMode("Driving")}>
              <FontAwesomeIcon icon={solid("car")} /> Driving
            </button>
          </div>
        </div>
        <div className="dd-section">
          <span className="dd-section-label">Route</span>
          <div className="dd-card">
            <button className="dd-selector-row" onClick={() => selectPlaces("from place")}>
              <FontAwesomeIcon icon={solid("circle-dot")} className="dd-row-icon dd-icon-from" />
              <span className={`dd-selector-label${DirectionsFromLocation === null ? " placeholder" : ""}`}>
                {DirectionsFromLocation === null ? "From" : DirectionsFromLocation.Name}
              </span>
              <FontAwesomeIcon icon={solid("chevron-right")} className="dd-selector-chevron" />
            </button>
            <div className="dd-divider" />
            <button className="dd-selector-row" onClick={() => selectPlaces("waypoints")}>
              <FontAwesomeIcon icon={solid("ellipsis-vertical")} className="dd-row-icon dd-icon-waypoint" />
              <span className={`dd-selector-label${DirectionsWaypointsLocation.length === 0 ? " placeholder" : ""}`}>
                {DirectionsWaypointsLocation.length === 0 ? "Waypoints (optional)" : `${DirectionsWaypointsLocation.length} waypoint${DirectionsWaypointsLocation.length === 1 ? "" : "s"}`}
              </span>
              <FontAwesomeIcon icon={solid("chevron-right")} className="dd-selector-chevron" />
            </button>
            {DirectionsWaypointsLocation.length > 1 && (
              <div className="dd-waypoint-order">
                {DirectionsWaypointsLocation.map((wp, i) => (
                  <div className="dd-waypoint-row" key={`${wp.Name}-${i}`}>
                    <span className="dd-waypoint-index">{i + 1}</span>
                    <span className="dd-waypoint-name">{wp.Name}</span>
                    <button
                      className="dd-waypoint-move"
                      disabled={i === 0}
                      onClick={() => moveWaypoint(i, -1)}
                      title="Move up"
                    >
                      <FontAwesomeIcon icon={solid("chevron-up")} />
                    </button>
                    <button
                      className="dd-waypoint-move"
                      disabled={i === DirectionsWaypointsLocation.length - 1}
                      onClick={() => moveWaypoint(i, 1)}
                      title="Move down"
                    >
                      <FontAwesomeIcon icon={solid("chevron-down")} />
                    </button>
                  </div>
                ))}
              </div>
            )}
            {DirectionsWaypointsLocation.length > 0 && (
              <div className={`dd-waypoint-limit-note${DirectionsWaypointsLocation.length > GOOGLE_MAPS_WAYPOINT_LIMIT ? " over" : ""}`}>
                {DirectionsWaypointsLocation.length > GOOGLE_MAPS_WAYPOINT_LIMIT
                  ? `Google Maps only reliably follows up to ${GOOGLE_MAPS_WAYPOINT_LIMIT} waypoints between From and To (${GOOGLE_MAPS_WAYPOINT_LIMIT + 2} stops total) — ${DirectionsWaypointsLocation.length - GOOGLE_MAPS_WAYPOINT_LIMIT} may be dropped or reordered.`
                  : `Google Maps supports up to ${GOOGLE_MAPS_WAYPOINT_LIMIT} waypoints between From and To (${GOOGLE_MAPS_WAYPOINT_LIMIT + 2} stops total).`}
              </div>
            )}
            <div className="dd-divider" />
            <button className="dd-selector-row" onClick={() => selectPlaces("to place")}>
              <FontAwesomeIcon icon={solid("location-dot")} className="dd-row-icon dd-icon-to" />
              <span className={`dd-selector-label${DirectionsToLocation === null ? " placeholder" : ""}`}>
                {DirectionsToLocation === null ? "To" : DirectionsToLocation.Name}
              </span>
              <FontAwesomeIcon icon={solid("chevron-right")} className="dd-selector-chevron" />
            </button>
          </div>
        </div>
        {working && (
          <div className="dd-working-note">
            <FontAwesomeIcon icon={solid("spinner")} spin /> {Operation === "Draw" ? "Drawing route…" : "Working…"}
          </div>
        )}
        {!working && !!drawSuccessMsg && <div className="dd-success-note">{drawSuccessMsg}</div>}
        <div className="dd-footer-inline">
          <button className="dd-clear-btn" onClick={() => DeleteDirectionsMarkers()}>Clear</button>
          <button className="dd-go-btn" onClick={() => getDirections()} disabled={working}>
            <FontAwesomeIcon icon={solid("arrow-right")} /> {working ? "Working…" : "Go"}
          </button>
        </div>
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      </div>
    );
  }
};

export default DirectionsDialogComponent;
